(function () {
  'use strict';
  function compactBanner(document, copy) {
    const banner = document.getElementById('shopify-pc__banner');
    if (!banner || !copy || typeof copy.body !== 'string' || !copy.body.trim()
      || typeof copy.accept !== 'string' || !copy.accept.trim()) return;
    const paragraph = banner.querySelector('.shopify-pc__banner__body p');
    const policy = banner.querySelector('#shopify-pc__banner__body-policy-link');
    if (paragraph && policy) {
      const message = copy.body + ' ';
      if (paragraph.childNodes.length !== 2 || paragraph.firstChild.nodeType !== 3
        || paragraph.firstChild.textContent !== message || paragraph.lastChild !== policy) {
        paragraph.replaceChildren(document.createTextNode(message), policy);
      }
      if (typeof copy.privacyUrl === 'string' && copy.privacyUrl.startsWith('/')
        && !copy.privacyUrl.startsWith('//') && policy.getAttribute('href') !== copy.privacyUrl) {
        policy.setAttribute('href', copy.privacyUrl);
      }
    }
    const labels = {
      accept: '#shopify-pc__banner__btn-accept',
      decline: '#shopify-pc__banner__btn-decline',
      preferences: '#shopify-pc__banner__btn-manage-prefs span',
      privacy: '#shopify-pc__banner__body-policy-link',
      title: '#shopify-pc__banner__body-title',
    };
    Object.entries(labels).forEach(([key, selector]) => {
      const node = banner.querySelector(selector);
      if (node && typeof copy[key] === 'string' && copy[key].trim() && node.textContent !== copy[key]) {
        node.textContent = copy[key];
      }
    });
  }
  function positionBanner(document, view) {
    const banner = document.getElementById('shopify-pc__banner');
    if (!banner) return;
    const purchase = document.querySelector('.messagerSticky');
    let offset = 0;
    if (purchase) {
      const style = view.getComputedStyle(purchase);
      const rect = purchase.getBoundingClientRect();
      if (style.display !== 'none' && style.visibility !== 'hidden' && rect.height > 0
        && rect.bottom > 0 && rect.top < view.innerHeight) {
        offset = Math.ceil(view.innerHeight - Math.max(0, rect.top));
      }
    }
    const value = offset + 'px';
    if (banner.style.getPropertyValue('--hlx-cookie-purchase-offset') !== value) {
      banner.style.setProperty('--hlx-cookie-purchase-offset', value);
    }
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { compactBanner, positionBanner };
    return;
  }
  const source = document.getElementById('hlx-cookie-banner-copy');
  if (!source) return;
  let copy;
  try { copy = JSON.parse(source.textContent); } catch (_) { return; }
  let purchase;
  let pending = false;
  const schedule = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; update(); });
  };
  const resize = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
  const purchaseChanges = new MutationObserver(schedule);
  function update() {
    const current = document.querySelector('.messagerSticky');
    if (current !== purchase) {
      if (resize) resize.disconnect();
      purchaseChanges.disconnect();
      purchase = current;
      if (purchase) {
        if (resize) resize.observe(purchase);
        purchaseChanges.observe(purchase, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
      }
    }
    compactBanner(document, copy);
    positionBanner(document, window);
  }
  update();
  new MutationObserver(schedule).observe(document.body, {
    childList: true, subtree: true,
  });
  const pageChanges = new MutationObserver(schedule);
  [document.documentElement, document.body].forEach(node => pageChanges.observe(node, {
    attributes: true, attributeFilter: ['class', 'style'],
  }));
  window.addEventListener('resize', schedule, { passive: true });
  if (window.visualViewport) window.visualViewport.addEventListener('resize', schedule, { passive: true });
})();
